import React, { Fragment } from 'react';
import ReactDOM, { render } from "react-dom";
import pngData from "./propositionWarning/warnpng"
import './propositionWarning/style.css';

export default ({ message }) => <table>
    <tr>
        <td>
            <div id="WarningMsgId" className="WarningMsg">
				<img src={pngData} className="WarningIcon"/> 
				<strong>WARNING:</strong> {message} For more information go to: <a href="https://www.p65warnings.ca.gov/" target="_blank">www.P65Warnings.ca.gov.</a>
            </div>
        </td>
    </tr>
</table >